import * as R from 'ramda';
import { reduxHelper } from 'utils/reduxHelper';

import { GlobalState } from 'reactApp/core/rootReducer';
import { getServiceSelectors } from 'reactApp/modules/ServiceModule/ServiceModule';
import * as ServiceTypes from 'reactApp/modules/ServiceModule/ServiceModule.types';

const basicSelectors = getServiceSelectors('infra');

const getModuleState = (state: GlobalState) =>
    basicSelectors.getModuleState(state) as ServiceTypes.InfraData;

const getHorizonUrl = R.pipe(getModuleState, (state) => state.dashboard_url);

const getOsProjectId = R.pipe(getModuleState, (state) => state.os_project_id);

export const InfraServiceSelectors = {
    ...basicSelectors,
    getHorizonUrl,
    getOsProjectId,
};

export const BoundInfraServiceSelectors = reduxHelper.bindSelectors<
    typeof InfraServiceSelectors
>(InfraServiceSelectors);
